<i18n locale="en">
{
  "options": {
    "logo-left": "Left",
    "logo-center": "Center"
  },
  "label": "Logo Position"
}
</i18n>

<template>
  <OwnInputContainer :label="t('label')">
    <OwnSegmentedControl
      :options="options"
      :model-value="logoPosition"
      @update:model-value="onLayoutChange"
    />
  </OwnInputContainer>
</template>

<script>
import set from 'lodash/set'
import { useI18n } from 'vue-i18n'
import { mapActions, mapGetters } from 'vuex'

import { OwnInputContainer } from '@/ui/OwnInputContainer'
import { OwnSegmentedControl } from '@/ui/OwnSegmentedControl'

export default {
  name: 'LogoPositionEditor',
  components: {
    OwnInputContainer,
    OwnSegmentedControl,
  },
  setup() {
    const { t } = useI18n()

    return { t }
  },
  computed: {
    ...mapGetters({
      currentResource: 'websiteBuilder/currentResource',
    }),
    logoPosition() {
      const { currentResource } = this

      return currentResource?.funnel?.navigation?.layout
    },
    options() {
      return [
        {
          value: 'logo-left',
        },
        {
          value: 'logo-center',
        },
      ].map((option) => ({
        ...option,
        label: this.t(`options.${option.value}`),
      }))
    },
  },
  methods: {
    ...mapActions({
      updateResource: 'websiteBuilder/updateResource',
    }),
    onLayoutChange(newPosition) {
      this.updateResource(set({}, 'funnel.navigation.layout', newPosition))
    },
  },
}
</script>
